/**
 * SalesRidge launch / relaunch button visibility (mirrors backend SalesRidgeLaunchUi).
 *
 * @param {object|null|undefined} launchUi
 * @returns {boolean}
 */
export function shouldShowSalesridgeLaunchButton(launchUi) {
  return !!(launchUi && launchUi.show_launch_button);
}

/**
 * True when preview vs saved total differs enough to warn (not first-launch-only).
 *
 * @param {object|null|undefined} launchUi
 * @returns {boolean}
 */
export function shouldShowSalesridgeMismatchBanner(launchUi) {
  if (!launchUi) {
    return false;
  }

  return !!(
    launchUi.has_total_mismatch ||
    launchUi.stuck_empty_search ||
    launchUi.remote_empty_search
  );
}

/**
 * @param {object|null|undefined} launchUi
 * @returns {string}
 */
export function salesridgeLaunchButtonLabel(launchUi) {
  const status = launchUi && launchUi.launch_status;
  if (status === "launched") {
    return "Relaunch SalesRidge search";
  }
  return "Launch SalesRidge search";
}

/**
 * User-facing relaunch / launch API errors (maps backend message codes to i18n).
 *
 * @param {import('vue-i18n').default} i18n
 * @param {object|string|null} err
 * @returns {string}
 */
export function formatSalesridgeRelaunchError(i18n, err) {
  if (!err) {
    return i18n.t("lang.search.filter_relaunch_salesridge_error");
  }

  if (typeof err === "string") {
    return err;
  }

  const code = err.message || "";
  if (code === "salesridge_search_failed") {
    return i18n.t("lang.search.salesridge_launch_failed_filters");
  }

  if (code === "datita_build_failed" || (Array.isArray(err.filter_gaps) && err.filter_gaps.length)) {
    if (err.detail) {
      return String(err.detail);
    }
    const gaps = Array.isArray(err.filter_gaps) ? err.filter_gaps : [];
    if (gaps.length) {
      return `Could not build SalesRidge filters — missing or unmappable targeting:\n• ${gaps.join("\n• ")}`;
    }
  }

  if (err.detail) {
    return String(err.detail);
  }

  return i18n.t("lang.search.filter_relaunch_salesridge_error");
}
